import { TFunction } from 'i18next';

import { I18nNamespace } from '~/common/types';
import { ProgressIndicatorAlternatingProps } from '~/components/ProgressIndicator/ProgressIndicatorAlternating';

export const createUploadIndicatorAlternatingProps = (
  t: TFunction<I18nNamespace.intake, undefined>,
): ProgressIndicatorAlternatingProps => {
  return {
    messages: [
      t('processingStates.analyzing'),
      t('processingStates.checking'),
      t('processingStates.structuring'),
      t('processingStates.writing'),
      t('processingStates.end'),
    ],
  };
};
